import { useTranslation } from "react-i18next";

import { ASSET_CLASSES } from "../../OnboardingAPI";
import { Field, selectClass } from "../Fields";
import { Collapse } from "../calm";
import { StepBody, StepFooter, StepHeading } from "../StepCard";
import { numberedCount } from "../steps";
import { OWNERSHIPS } from "../useOnboardingController";
import type { StepContext } from "./shared";

/**
 * "Deine Immobilien": the kind of the properties and the role the person has for them. Both are an answer, not a
 * requirement: the step counts as done once the kind is chosen, but "Weiter" is never held back.
 */
export default function PropertiesStep({ ctx }: { ctx: StepContext }) {
  const { c } = ctx;
  const { t } = useTranslation();
  const profile = c.values!.profile;

  return (
    <>
      <StepBody>
        <StepHeading
          eyebrow={t("onboardingPage.nav.stepOf", { current: ctx.step.index, total: numberedCount(ctx.steps) })}
          title={t("onboardingPage.titles.properties")}
          lead={t("onboardingPage.properties.lead")}
          focus={ctx.focus}
        />
        <Collapse open={!!ctx.nudge}>
          <p role="status" className="rounded-xl bg-muted/60 px-4 py-3 text-sm">{ctx.nudge}</p>
        </Collapse>

        <div className="grid gap-4 sm:grid-cols-2" data-testid="properties-fields">
          <Field id="onboarding-assetClass" label={t("onboardingPage.company.assetClass")}>
            <select id="onboarding-assetClass" className={selectClass} value={profile.assetClass ?? ""} onChange={(event) => c.updateProfile("assetClass", event.target.value)}>
              <option value="">{t("onboardingPage.choose")}</option>
              {ASSET_CLASSES.map((assetClass) => (
                <option key={assetClass} value={assetClass}>
                  {t(`onboardingPage.company.assetClasses.${assetClass}`)}
                </option>
              ))}
            </select>
          </Field>
          <Field id="onboarding-ownership" label={t("onboardingPage.company.ownership")}>
            <select id="onboarding-ownership" className={selectClass} value={profile.ownership ?? ""} onChange={(event) => c.updateProfile("ownership", event.target.value)}>
              <option value="">{t("onboardingPage.choose")}</option>
              {OWNERSHIPS.map((ownership) => (
                <option key={ownership} value={ownership}>
                  {t(`onboardingPage.company.ownerships.${ownership}`)}
                </option>
              ))}
            </select>
          </Field>
        </div>
      </StepBody>
      <StepFooter onBack={ctx.back} onNext={ctx.next} />
    </>
  );
}
